// Central API helper. Backend is same-origin behind nginx at /api.

export const API_BASE =
  (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const TOKEN_KEY = "fs_editor_token";

export const getToken = () =>
  localStorage.getItem(TOKEN_KEY);

export const setToken = (t) =>
  localStorage.setItem(TOKEN_KEY, t);

export const clearToken = () =>
  localStorage.removeItem(TOKEN_KEY);

async function request(
  path,
  { method = "GET", body, auth = false } = {}
) {
  const headers = {};

  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
  }

  if (auth) {
    const token = getToken();

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body:
      body !== undefined
        ? JSON.stringify(body)
        : undefined,
  });

  let data = null;

  try {
    data = await res.json();
  } catch (_) {
    // Empty / non-JSON response
  }

  if (!res.ok) {
    const msg =
      (data && data.detail) ||
      `Request failed (${res.status})`;

    const err = new Error(msg);
    err.status = res.status;

    throw err;
  }

  return data;
}

export const api = {
  // Content
  getContent: () =>
    request("/content"),

  saveContent: (lang, content) =>
    request("/content", {
      method: "PUT",
      body: { lang, content },
      auth: true,
    }),

  getHistory: () =>
    request("/content/history", {
      auth: true,
    }),

  restoreVersion: (id) =>
    request(`/content/restore/${id}`, {
      method: "POST",
      auth: true,
    }),

  // Authentication
  login: (email, password) =>
    request("/auth/login", {
      method: "POST",
      body: { email, password },
    }),

  forgotPassword: (email) =>
    request("/auth/forgot-password", {
      method: "POST",
      body: { email },
    }),

  resetPassword: (token, new_password) =>
    request("/auth/reset-password", {
      method: "POST",
      body: { token, new_password },
    }),

  me: () =>
    request("/auth/me", {
      auth: true,
    }),

  changePassword: (
    current_password,
    new_password
  ) =>
    request("/auth/change-password", {
      method: "POST",
      body: {
        current_password,
        new_password,
      },
      auth: true,
    }),

  // Users
  listUsers: () =>
    request("/auth/users", {
      auth: true,
    }),

  createUser: (email, password) =>
    request("/auth/users", {
      method: "POST",
      body: {
        email,
        password,
      },
      auth: true,
    }),

  resetUserPassword: (
    email,
    new_password
  ) =>
    request(
      `/auth/users/${encodeURIComponent(email)}/reset-password`,
      {
        method: "POST",
        body: {
          new_password,
        },
        auth: true,
      }
    ),

  deleteUser: (email) =>
    request(
      `/auth/users/${encodeURIComponent(email)}`,
      {
        method: "DELETE",
        auth: true,
      }
    ),

  // News
  getNews: (all = false) =>
    request(
      `/news${all ? "?all=true" : ""}`
    ),

  getNewsArticle: (slug) =>
    request(
      `/news/${encodeURIComponent(slug)}`
    ),

  createNews: (item) =>
    request("/news", {
      method: "POST",
      body: item,
      auth: true,
    }),

  updateNews: (id, item) =>
    request(`/news/${id}`, {
      method: "PUT",
      body: item,
      auth: true,
    }),

  deleteNews: (id) =>
    request(`/news/${id}`, {
      method: "DELETE",
      auth: true,
    }),
};